<template>
  <span v-if="!rights.includes('hide_patient_phone')">
    <a v-if="outgoingCallThrough === 'standard'"
       :href="`tel:${phone}`">
      {{ formatPhone(phone) }}
    </a>
    <a v-else
       @click="makeCall"
       class="pointer"
       :class="`text-${color}`">
      {{ formatPhone(phone) }}
    </a>
  </span>
</template>

<script setup>
import { makeCall as callThroughTelephony } from "@/services/call.service"
import {formatPhone} from "@/extensions/filters/filters"
import i18n from "@/lang/i18n"
import { computed, getCurrentInstance } from "vue"
import { useStore } from "vuex"

const props = defineProps({
  phone: {
    required: true
  },
  color: {
    type: String,
    default: 'primary'
  }
})

const store = useStore()
const noty = getCurrentInstance()?.appContext?.app?.noty

const clinic = computed(() => store.state.auth.clinic)
const rights = computed(() => store.state.auth.rights)
// standard: a tel: link; otherwise the call goes through the telephony of the clinic
const outgoingCallThrough = computed(() => clinic.value?.clinic_additional?.outgoing_calls || 'standard')

const makeCall = async () => {
  const res = await callThroughTelephony(clinic.value, props.phone)
  if(res?.data) {
    noty.info(i18n.global.t('success_message'))
  } else {
    noty.error(i18n.global.t('error_message'))
  }
}
</script>
